import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {userActions, alertActions} from '../actions'
import CircularProgress from '@material-ui/core/CircularProgress'

// withCheckLoginState function takes a component and wraps a set TimeOut logic around it
const withCheckLoginState = WrappedComponent => {
    class WithCheckLoginState extends Component {
        componentDidMount() {
            const {
                token,
                tokenrefresh,
                loggedIn,
                exp,
                logout,
                loginCheck,
                timeoutWarning,
                errorAlert,
                swipeeventoccurrence,
            } = this.props

            const {isKiosk} = swipeeventoccurrence
            const autoExtendSession = isKiosk === 'Y' ? true : false

            loginCheck(loggedIn)

            if (token) {
                try {
                    const expirytime = exp

                    const timeoutwarning = Math.ceil(
                        (expirytime - Date.now() / 1000 - 60) * 1000
                    )
                    let timeout = expirytime * 1000 - Date.now()

                    this.timeoutWarn = autoExtendSession
                        ? setTimeout(() => {
                              tokenrefresh(token, true)
                          }, timeoutwarning)
                        : setTimeout(() => {
                              timeoutWarning(
                                  'Session about to expire. You will be logged out in 1 minute. Extend session?'
                              )
                          }, timeoutwarning)

                    this.timeoutLogout = setTimeout(
                        () =>
                            logout(
                                'Logged out because your session has expired'
                            ),
                        timeout
                    )
                } catch (e) {
                    errorAlert(e)
                }
            }
        }

        componentDidUpdate() {
            const {
                token,
                tokenrefresh,
                exp,
                logout,
                timeoutWarning,
                errorAlert,
                swipeeventoccurrence,
            } = this.props

            const {isKiosk} = swipeeventoccurrence
            const autoExtendSession = isKiosk === 'Y' ? true : false

            if (token) {
                clearTimeout(this.timeoutWarn)
                clearTimeout(this.timeoutLogout)
                try {
                    const expirytime = exp

                    const timeoutwarning = Math.ceil(
                        (expirytime - Date.now() / 1000 - 60) * 1000
                    )
                    let timeout = expirytime * 1000 - Date.now()

                    this.timeoutWarn = autoExtendSession
                        ? setTimeout(() => {
                              tokenrefresh(token, true)
                          }, timeoutwarning)
                        : setTimeout(() => {
                              timeoutWarning(
                                  'Session about to expire. You will be logged out in 1 minute. Extend session?'
                              )
                          }, timeoutwarning)

                    this.timeoutLogout = setTimeout(
                        () =>
                            logout(
                                'Logged out because your session has expired'
                            ),
                        timeout
                    )
                } catch (e) {
                    errorAlert(e)
                }
            }
        }

        componentWillUnmount() {
            clearTimeout(this.timeoutWarn)
            clearTimeout(this.timeoutLogout)
        }

        render() {
            const {
                loggedIn,
                checkingLoginStatus,
                roles,
                admin,
                activedepartment,
            } = this.props

            const deptAdmin =
                'admin' in roles
                    ? roles.admin.length > 0
                        ? true
                        : false
                    : false
            const deptCreator =
                'creator' in roles
                    ? roles.creator.length > 0
                        ? true
                        : false
                    : false

            const userrole = admin
                ? 'Super Admin'
                : deptAdmin
                ? 'Department Admin'
                : deptCreator
                ? 'Department Creator'
                : 'Swiper'

            const activedeptAdmin =
                'admin' in roles
                    ? roles.admin.indexOf(activedepartment) > -1
                        ? true
                        : false
                    : false
            const activedeptCreator =
                'creator' in roles
                    ? roles.creator.indexOf(activedepartment) > -1
                        ? true
                        : false
                    : false

            const activedeptuserrole = admin
                ? 'Super Admin'
                : activedeptAdmin
                ? 'Department Admin'
                : activedeptCreator
                ? 'Department Creator'
                : 'Swiper'

            return checkingLoginStatus ? (
                <div align="center" style={{margin: '200px'}}>
                    <CircularProgress
                        style={{color: '#00853e'}}
                        thickness={5}
                    />
                </div>
            ) : loggedIn ? (
                <WrappedComponent
                    userrole={userrole}
                    activedeptuserrole={activedeptuserrole}
                />
            ) : (
                <Redirect to="/" />
            )
        }
    }

    function mapStateToProps(state) {
        return {
            token: state.authentication.token,
            loggedIn: state.authentication.loggedIn,
            exp: state.authentication.exp,
            checkingLoginStatus: state.authentication.checkingLoginStatus,
            roles: state.authentication.roles,
            admin: state.authentication.admin,
            activedepartment: state.departmentsdata.activedepartment,
            swipeeventoccurrence: state.occurrencedata.occurrence,
        }
    }

    const mapDispatchToProps = {
        loginCheck: loggedIn => userActions.loginCheck(loggedIn),
        logout: message => userActions.logout(message),
        tokenrefresh: (token, noalertmsg) =>
            userActions.tokenrefresh(token, noalertmsg),
        timeoutWarning: warningMsg => alertActions.warning(warningMsg),
        errorAlert: message => alertActions.error(message),
    }

    // Connect to global store
    // Subscribe to specific slice of store and Actions
    return connect(mapStateToProps, mapDispatchToProps)(WithCheckLoginState)
}

export default withCheckLoginState
